import React from "react";
import {
  CaAdminMenu,
  SecondaryNavCaAdmin,
} from "../../../components/AdminComponents/MenuItems";

import { useParams } from "react-router-dom";

// eslint-disable-next-line no-unused-vars
import { InfoCircleTwoTone } from "@ant-design/icons";
import { useSelector } from "react-redux";
import UsersTable2 from "../../../components/AdminComponents/UserTable2";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
const Relationships = () => {
  const { id } = useParams();
  // eslint-disable-next-line no-unused-vars
  const namingData = useSelector((state) => state.orgdeatil);
  return (
    <div>
      <CaSideNav props={CaAdminMenu}>
        <SecondaryNav2 menuItems={SecondaryNavCaAdmin} id={parseInt(id)} />
        {/* <div className="details-box">
          <InfoCircleTwoTone style={{ fontSize: "2rem" }} />
          <span className="details-text">
            <strong>Client ID</strong> : {namingData.id}&nbsp;&nbsp;{" "}
            <strong>Client Name</strong> : {namingData.name}
          </span>
        </div> */}
        <UsersTable2 />
      </CaSideNav>
    </div>
  );
};

export default Relationships;
